// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"ccc2bb76","239":"8842cf4e","453":"d456ce70"}[chunkId] + ".chunk.js";
};